import { createStore } from 'vuex'

export default createStore({
  state: {
    appName: "Asdecode Superviseur",
    // apiUrl: 'http://127.0.0.1:9090',
    apiUrl: 'https://asdecode.com',
    authenticated: false,
    user: null,
    token: '',
  },
  getters: {
    authenticated: (state) => state.authenticated,
    user: (state) => state.user,
    apiUrl: (state) => state.apiUrl,
    appName: (state) => state.appName,
  },
  mutations: {
    setAuthenticated(state, payload) {
      state.user = payload.user;
      state.token = payload.token;
      state.authenticated = true;
      const userDatas = {
        user: payload.user,
        token: payload.token,
      };
      window.localStorage.setItem('asdecode_superviseur', JSON.stringify(userDatas));
    },
    setUser(state, user) {
      if (state.user) {
        state.user = user;
      }
      const userDatas = {
        user: state.user,
        token: state.token,
      };
      window.localStorage.setItem('asdecode_superviseur', JSON.stringify(userDatas));
    },
    clearUserData(state) {
      state.user = null;
      state.token = '';
      state.authenticated = false;
      window.localStorage.removeItem('asdecode_superviseur');
    },
  },
  actions: {
  },
  modules: {
  }
})
